import { ThemeInfo } from "go2sim-types"
import { Theme } from "go2sim-types/dist/enumerations/themes"

const themeInfo:ThemeInfo[] = [
  {
    theme: Theme.ORIGINAL,
    images: {
      brandLogo1: "/img/branding/simui-classic-1.png",
      brandLogo2: "/img/branding/simui-classic-2.png",
      brandLogo3: "/img/branding/simui-classic-3.png"
    }
  },
  {
    theme: Theme.RETRO,
    images: {
      brandLogo1: "/img/branding/simui-retro-1.png",
      brandLogo2: "/img/branding/simui-retro-2.png",
      brandLogo3: "/img/branding/simui-retro-3.png"
    }
  }
]

export default themeInfo